import { render, staticRenderFns } from "./DifferentialExpression.vue?vue&type=template&id=9fac5fc4&scoped=true"
import script from "./DifferentialExpression.vue?vue&type=script&lang=js"
export * from "./DifferentialExpression.vue?vue&type=script&lang=js"
import style0 from "./DifferentialExpression.vue?vue&type=style&index=0&id=9fac5fc4&prod&scoped=true&lang=css"
import style1 from "./DifferentialExpression.vue?vue&type=style&index=1&id=9fac5fc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fac5fc4",
  null
  
)

export default component.exports